<div class="flex flex-col gap-0 {{otherClasses}}">
  <span class="bg-gray-100 px-2 py-2 rounded text-gray-500 font-bold" *ngIf="key">{{ key | translate }}</span>
  @if (customView) {
    <span class="p-2 {{ hasBorder ? 'border-b border-dashed border-gray-200  mt-1' : ''}}">
      <ng-container
        [ngTemplateOutlet]="customView">
      </ng-container>
    </span>
  } @else {
    <span
      class="p-2 border-b border-dashed border-gray-200 mt-1">
      <span
        *ngIf="valueType != 'date' && valueType != 'number' && valueType != 'html'">{{ value | valueChecker }}</span>
      <span *ngIf="valueType == 'number'">{{ value | number }}</span>
      <span *ngIf="valueType == 'date'">{{ value | date }}</span>
      <span *ngIf="valueType == 'html'" [innerHtml]="value"></span>
    </span>
  }
</div>
